import React from 'react';
import { Fab, Tooltip } from '@mui/material';
import HelpCenterIcon from '@mui/icons-material/HelpCenter';
import { useTranslation } from 'react-i18next';
import { assetLanguage } from 'src/utils/assetLanguage';

export default function FloatingHelpCenter() {
  const { t, i18n } = useTranslation();

  const handleHelpClick = () => {
    // TODO: Add help center functionality
    window.open(
      `https://assets.envirly.pl/raben/surveys/${assetLanguage(
        i18n.language
      )}/supplier_survey.pdf`,
      '_blank',
      'noopener,noreferrer'
    );
  };

  return (
    <Tooltip title={t('menu.helpCenter')} placement="left">
      <Fab
        color="primary"
        aria-label={
          i18n.language === 'ro' ? t('menu.helpCenter') : 'help center'
        }
        onClick={handleHelpClick}
        sx={{
          position: 'fixed',
          bottom: 24,
          right: 24,
          zIndex: 1000,
          backgroundColor: '#E30311',
          '&:hover': {
            backgroundColor: '#C50210',
          },
        }}
      >
        <HelpCenterIcon />
      </Fab>
    </Tooltip>
  );
}
